(function () {
  'use strict';
  function picker(form) { return form && form.querySelector('.ro-size-choice'); }
  function validate(form) {
    var select = picker(form);
    if (!select) {
      var raw = form && form.querySelector('select[name="id"]');
      var option = raw && raw.selectedOptions[0];
      return !(option && /choose size/i.test(option.textContent));
    }
    if (!select.value || select.selectedOptions[0].disabled) {
      select.setCustomValidity(select.closest('.ro-size-guard').querySelector('.ro-size-help').textContent);
      select.reportValidity();
      select.focus();
      return false;
    }
    select.setCustomValidity('');
    var actual = form.querySelector('[name="id"]');
    if (actual) actual.value = select.value;
    return true;
  }
  function promptButtons(form) {
    var select = picker(form);
    if (!select || select.value || !Array.from(select.options).some(function (option) { return option.value && !option.disabled; })) return;
    form.querySelectorAll('button[type="submit"]').forEach(function (button) {
      if (button.disabled) button.disabled = false;
      var label = button.querySelector('.product-form__cart-submit-text') || button;
      if (label.textContent !== select.options[0].text) label.textContent = select.options[0].text;
    });
  }
  function init(root) {
    root.querySelectorAll('.ro-size-guard').forEach(function (guard) {
      var form = guard.closest('form');
      if (form) {
        form.classList.add('ro-size-required');
        if (!form.dataset.roGuardReady) {
          form.dataset.roGuardReady = 'true';
          new MutationObserver(function () { promptButtons(form); }).observe(form, {childList:true, subtree:true, attributes:true, attributeFilter:['disabled']});
        }
        promptButtons(form);
      }
      document.body.classList.add('ro-has-size-guard');
    });
  }
  document.addEventListener('change', function (event) {
    if (!event.target.matches('.ro-size-choice')) return;
    event.stopImmediatePropagation();
    var select = event.target;
    var guard = select.closest('.ro-size-guard');
    select.setCustomValidity('');
    document.querySelectorAll('.ro-size-guard').forEach(function (other) {
      if (other.dataset.productId !== guard.dataset.productId) return;
      var otherSelect = other.querySelector('.ro-size-choice');
      otherSelect.value = select.value;
      otherSelect.setCustomValidity('');
      var form = other.closest('form');
      var original = form && form.querySelector('[name="id"]');
      if (original) {
        original.value = select.value;

      }
    });
    var variant = JSON.parse(select.selectedOptions[0].dataset.variant);
    var container = guard.closest('.product-template');
    if (container && window.jQuery) {
      ['variantChange', 'variantPriceChange', 'variantSKUChange'].forEach(function (type) { window.jQuery(container).trigger({type: type, variant: variant}); });
    }
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.matches('form[action*="/cart/add"]') && !validate(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', function (event) {
    var button = event.target.closest('button[type="submit"], input[type="submit"]');
    var form = button && button.closest('form');
    if (picker(form) && !validate(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    var guide = event.target.closest('.ro-size-guide-link');
    if (guide) document.querySelectorAll('#tab-description details').forEach(function (detail) { detail.open = true; });
  }, true);
  if (window.ShopifyAPI && window.ShopifyAPI.addItemFromForm) {
    var originalAdd = window.ShopifyAPI.addItemFromForm;
    window.ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
      var element = form && form.jquery ? form[0] : form;
      if (!validate(element)) return;
      return originalAdd.apply(this, arguments);
    };
  }
  init(document);
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
